import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const defaultValue = { projects: [], loading: true, error: "", refresh: async () => {} };
const Ctx = createContext(defaultValue); // <-- not null

export function ProjectsProvider({ children }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get("/api/projects");
        const raw = res?.data?.data || res?.data || [];
        const arr = Array.isArray(raw) ? raw : raw.projects || [];
        const normalized = arr.map((p) => ({
          ...p,
          _id: String(p._id),
          Latitude: typeof p.Latitude === "string" ? parseFloat(p.Latitude) : p.Latitude,
          Longitude: typeof p.Longitude === "string" ? parseFloat(p.Longitude) : p.Longitude,
        }));
        if (!cancelled) setProjects(normalized);
      } catch (e) {
        if (!cancelled) setError("Failed to load projects");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const value = useMemo(() => ({
    projects, loading, error,
    refresh: async () => {
      setLoading(true);
      try {
        const res = await axios.get("/api/projects");
        const raw = res?.data?.data || res?.data || [];
        const arr = Array.isArray(raw) ? raw : raw.projects || [];
        const normalized = arr.map((p) => ({
          ...p,
          _id: String(p._id),
          Latitude: typeof p.Latitude === "string" ? parseFloat(p.Latitude) : p.Latitude,
          Longitude: typeof p.Longitude === "string" ? parseFloat(p.Longitude) : p.Longitude,
        }));
        setProjects(normalized);
      } finally {
        setLoading(false);
      }
    },
  }), [projects, loading, error]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useProjects = () => useContext(Ctx);
